import styled from 'styled-components';
import { P as PLACEMENTS, C as Container } from './index.styled2.js';
import { I as Input } from './index.styled7.js';

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var Label = styled.label.attrs({
  className: 'gz-checkbox__label'
}).withConfig({
  componentId: "gz-checkbox-1679041957665__sc-suiloy-0"
})(["color:#5b6c7f;cursor:pointer;font-size:14px;user-select:none;transition:color 120ms ease 0s;", " ", "[aria-invalid=\"true\"] ~ &,", "[aria-invalid=\"true\"][checked] ~ &{color:#f00314;}", ":hover > ", "[aria-invalid=\"true\"]:not([checked]) ~ &{color:#5b6c7f;}", "[aria-invalid=\"true\"]:disabled ~ &,", ":disabled ~ &,", "[aria-invalid=\"true\"][checked]:disabled ~ &,", "[checked]:disabled ~ &{color:#b6b6b6;cursor:not-allowed;}"], function (_ref) {
  var placement = _ref.placement;

  if (placement === PLACEMENTS.RIGHT) {
    return "\n        padding-left: 8px;\n      ";
  }

  if (placement === PLACEMENTS.LEFT) {
    return "\n        padding-right: 8px;\n      ";
  }

  if (placement === PLACEMENTS.TOP) {
    return "\n        padding-bottom: 8px;\n      ";
  }

  if (placement === PLACEMENTS.BOTTOM) {
    return "\n        padding-top: 8px;\n      ";
  }

  return '';
}, Input, Input, Container, Input, Input, Input, Input, Input);

export { Label as L };
